import { chatLogin } from "../../../helpers/apis";
import { loginSuccess, logoutUserSuccess, apiError } from "./reducer";
import { setAuthorization } from "../../../helpers/api_helper";
import { jwtDecode } from "jwt-decode";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    // Call login API
    const response = await chatLogin({
      email: user.email,
      password: user.password,
    });

    if (response && response.data) {
      const token = response.data; // Extract JWT token
      localStorage.setItem("authUser", JSON.stringify(response));

      console.log("Received Token:", token);

      // Decode JWT Token to get user details & expiry
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);

      // Save expiry time
      localStorage.setItem("expiryIn", decodedToken.exp * 1000);

      if (!response.error) {
        dispatch(loginSuccess(response));

        history("/dashboard");

        const expiryAt = new Date(decodedToken.exp * 1000); // Convert expiry to milliseconds
        localStorage.setItem("expiryAt", expiryAt.getTime());

        setAuthorization(token);
      } else {
        dispatch(apiError(response));
      }
    } else {
      throw new Error("Invalid API response: No token received.");
    }
  } catch (error) {
    console.error("Login Error:", error);
    dispatch(apiError(error.message || "An error occurred during login."));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("expiryAt");
    localStorage.removeItem("expiryIn");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    console.error("Logout Error:", error);
    dispatch(apiError(error.message || "An error occurred during logout."));
  }
};
